import React from 'react'

const FemaleSweeps = (props) => (
  		<div className="fineryCard whiteCard" style={props.swipeStyle}>
  			<div className="fineryCardContent bestLookDate">
          <div className="hatWoman"></div>
          <h3>WANT YOUR OWN LOOK RATED?</h3>
          <span>
            <strong>FINERY</strong> will help you create your looks.
          </span>
          <a href="http://www.finery.com/signup/match" className='fineryGenderButton'>create your look</a>
        </div>
  		</div>
)
export default FemaleSweeps;



// WEBPACK FOOTER //
// ./src/templates/FemaleSweeps.js